import React from "react";
import styled from "styled-components";
import MainMenu from "../Components/Main_Menu";
import Search from "./Search";
import SettingContent from "../Components/SettingContent";

const Setting = () => {
  return (
    <>
      <SettingWrap>
        <MainMenu />
        <SettingContentWrap>
          <SettingContent></SettingContent>
        </SettingContentWrap>
        <Search />
      </SettingWrap>
    </>
  );
};

export default Setting;

const SettingWrap = styled.div`
  width: 100%;

  background-color: #efefef;
  height: 100vh;

  @media (max-width: 767px) {
    max-width: 767px;
    width: 100%;
  }
`;

const SettingContentWrap = styled.div`
  width: calc(100% - 240px);

  position: relative;
  left: 120px;
  margin: 0 auto;

  @media (max-width: 1264px) {
    width: calc(100% - 80px);

    left: 40px;
  }

  @media (max-width: 767px) {
    width: 100%;
    left: 0;
  }
`;
